import * as React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle, Typography, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { withRouter } from '../common/with-router';
import { strains } from '../common/strains';

function EditStrain(props) {
  const [strain, setStrain] = React.useState(props.mouse?.strain || '');

  const handleStrainChange = (event) => {
    setStrain(event.target.value);
  };

  const handleSubmit = () => {
    const data = { strain };
    props.onSubmit(data);
    props.onClose();
  };

  return (
    <>
      <DialogTitle>Edit Mouse Strain</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 2 }}>
          <Typography variant="body1" gutterBottom>
            Mouse ID: {props.mouse?.id}
          </Typography>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Strain</InputLabel>
            <Select value={strain} onChange={handleStrainChange} label="Strain">
              {strains.map((s, index) => (
                <MenuItem key={index} value={s}>
                  {s}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={!strain}>
          Submit
        </Button>
      </DialogActions>
    </>
  );
}

export default withRouter(EditStrain);